module.exports = "<app-card-book-list [books]=\"books\"></app-card-book-list>"